import { models } from "types/api/viewModels.ts";
import { CabinetworksGroupApplication, CabinetworksGroupApplicationType } from "types/declarations/enums.ts";
import type { DashboardDestination, DashboardDestinations } from "./Dashboard.types";

const fallbackDestination = (path: string, application: CabinetworksGroupApplicationType): DashboardDestination => ({
	application,
	href: path
});

const findDestination = (
	navigation: models["NavigationViewModel"] | undefined,
	ids: string[],
	titles: string[],
	fallbackPath: string,
	fallbackApplication: CabinetworksGroupApplicationType = CabinetworksGroupApplication.Salesforce
): DashboardDestination => {
	const items = navigation?.menus?.flatMap((menu) => menu.items ?? []) ?? [];
	const item = items.find(
		(candidate) =>
			(candidate.id ? ids.includes(candidate.id) : false) ||
			(candidate.title ? titles.includes(candidate.title.trim().toLowerCase()) : false)
	);

	if (!item?.path) return fallbackDestination(fallbackPath, fallbackApplication);
	return {
		application: item.application ?? CabinetworksGroupApplication.Salesforce,
		href: item.path
	};
};

export const getDashboardDestinations = (navigation?: models["NavigationViewModel"]): DashboardDestinations => ({
	actionItems: findDestination(
		navigation,
		["nav-action-items", "nav-dashboard-action-items"],
		["action items"],
		"/action-items",
		CabinetworksGroupApplication.Tandem
	),
	news: findDestination(
		navigation,
		["nav-news", "nav-news-archive"],
		["news", "news archive"],
		"/news-archive",
		CabinetworksGroupApplication.Tandem
	),
	launches: findDestination(
		navigation,
		["nav-product-launch", "nav-product-launch-item", "nav-launches"],
		["launches", "product launches"],
		"/product-launches",
		CabinetworksGroupApplication.Tandem
	),
	software: findDestination(navigation, ["nav-software", "nav-software-item"], ["software"], "/sf/design-software"),
	filesAndLiterature: findDestination(
		navigation,
		["nav-products-all-products", "nav-product-resources", "nav-files-literature"],
		["all products", "product resources", "files & literature"],
		"/sf/resources"
	)
});
